import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BuildingContactRoleView } from '@api-proxies';
import {
    EditorComponentBase,
    GenericDropdownMultiselectComponent,
    IEditorItemConfig,
    IGenericTypeAheadDropdownConfig
} from 'ngx-lib';

export interface CompanyRolesEditorContext {
    roleOptions: BuildingContactRoleView[];
    selectedRoles: BuildingContactRoleView[];
    showValidationError: boolean;
    isLoading: boolean;
    hasLoadError: boolean;
    dropdownConfig: IGenericTypeAheadDropdownConfig<BuildingContactRoleView>;
}

@Component({
    selector: 'app-company-roles-dropdown-editor',
    templateUrl: './company-roles-dropdown-editor.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class CompanyRolesDropdownEditorComponent extends EditorComponentBase<BuildingContactRoleView[]> {
    state?: CompanyRolesEditorContext;

    override initialize(config: IEditorItemConfig): void {
        super.initialize(config);
        this.state = config.bindContext as CompanyRolesEditorContext;
    }

    onSelectedRolesChange(roles: BuildingContactRoleView[]): void {
        this.bindingProperty = roles;
        this.valueChange.emit();
    }
}
